export const getDraftShareIdFromQueryParam = () => {
	return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
